import { ExportCategory, type ExportSettingItem } from "./types";

export const ExportSettingsItems: ExportSettingItem[] = [
  {
    main: "Export settings",
    subItems: [
      ExportCategory.Installs,
      ExportCategory.Contracts,
      ExportCategory.IntentActivity,
      ExportCategory.FunctionalAreaIntelligence,
    ],
  },
  {
    main: "Spend Sheet",
    subItems: [
      ExportCategory.ITSpend,
      ExportCategory.ProductsAndVendors,
      ExportCategory.CloudMaturity,
    ],
  },
  {
    main: "Export",
  },
];

export const MAX_EXPORT_COMPANIES = 25000;

export const DIALOG_BODY_HEIGHT = "min(600px, calc(100vh - 220px))";
